<div class="professional-license-container directory-background">
    <div class="container">
        <div class="title">
            <a class="btn-close" (click)="onBackClick()" *ngIf="returnUrl">
                <mat-icon fontSet="phr-iconset" class="phr-iconset-PHR-Volver"></mat-icon> 
            </a>   
            <span>{{'shared.professionalLicense.title' | translate:locale.language}}</span>
        </div>
        <div class="doctor-img" *ngIf="avatarModel">
            <app-public-profile-avatar [model]="avatarModel"></app-public-profile-avatar>
        </div>
        <div class="doctor-sign" *ngIf="professionalLicense">
            <img [src]="professionalLicense.firma" alt="Firma" (error)="imgError($event)" class="doctor-sign">
            <div>
                {{license?.Nombre || professionalLicense.avatarModel.nombreResponsableServicio}}<br/>
                {{license?.Especialidad}}
                <br *ngIf="license?.Registro" />
                <span *ngIf="license?.Registro">Reg. {{license.Registro}} </span>
                <span *ngIf="license?.Folio">Cod. {{license.Codigo}} </span>
                <span *ngIf="license?.Folio">Folio {{license.Folio}}</span>
            </div>
        </div>
        <div class="verified-professional">
            <img src="/assets/images/cliniweb/medical-orders/check-verified.svg" class="check">
            {{'shared.professionalLicense.verifiedProfessionalTitle' | translate:locale.language}}
        </div>
        <div class="footer">
            <button mat-button mat-button mat-flat-button class="primary" (click)="goToPublicProfile()">
                {{'shared.professionalLicense.button' | translate:locale.language}}
            </button>
        </div>
    </div>
</div>